// extracted by mini-css-extract-plugin
export default {"top-bar":"top-bar--3Bd7m","black-background":"black-background--1K2Su","custom-logo":"custom-logo--ovDMJ"};